// Angular
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared/models/api-response.model';
import { RequestReceipt } from '@shared/models/request-receipt.model';
// Service
import { Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { SocketIoService } from './socket.io-service';

@Injectable({
  providedIn: 'root'
})
export class RequestReceiptHttpService {

  static requestReceipt: RequestReceipt = null;

  newRequestIncoming = new Subject<void>();
  messages$ = new Subject<any[]>();
  unsubscribeRequestReceipt: (() => void) | null = null;
  requestReceiptChannelName: string | null = null;


  constructor(private http: HttpClient, private socketIoService: SocketIoService) { }

  async init(memberAccountId: number) {
    await this.getRequestReceipt();
    if (await this.websocketInit()) {
      this.requestReceiptWebsocket(memberAccountId);
    };

  }

  update(depositId: number, data: { receipt_path?: string, status: number }) {
    return this.http.put<ApiResponse>(`/deposit/receipt/${depositId}`, data).pipe(
      tap(res => {
        this.messages$.next(res.message);
        RequestReceiptHttpService.requestReceipt = null;
        this.newRequestIncoming.next();
      }),
      map(res => res)
    );
  }

  private websocketInit() {
    return new Promise<boolean>((resolve, reject) => {
      // No need initialize websocket connection when in '/launch' page
      if (window.location.pathname !== '/gamelaunch') {
        let interval = setInterval(() => {
          const userToken = localStorage.getItem('user_token');
          const {
            access_token,
            plaintext_token,
          }: any = JSON.parse(userToken) || { access_token: undefined, plaintext_token: undefined };
          if (access_token && plaintext_token) {
            clearInterval(interval);
            resolve(true);
          }
        }, 1000);
      } else {
        resolve(false);
      }
    });
  }

  private getRequestReceipt() {
    return this.http.get<ApiResponse>(`/deposit/receipt/request`).pipe(
      map(res => res.data.rows[0]),
      tap((res: RequestReceipt) => {
        if (res) {
          res.reason = res.reason?.replace('Reason: ', '');
          RequestReceiptHttpService.requestReceipt = res;
          setTimeout(() => {
            this.newRequestIncoming.next();
          }, 1000); // Delay 1 seconds for better UX
        }
      })
    ).toPromise();
  }

  private requestReceiptWebsocket(memberAccountId: number) {
    this.requestReceiptChannelName = 'request-receipt-channel.' + memberAccountId;
    this.unsubscribeRequestReceipt = this.socketIoService
      .private(this.requestReceiptChannelName)
      .listen(`RequestReceiptEvent`, (data: RequestReceipt) => {
        if (data.status == 7) {
          data.reason = data.reason?.replace('Reason: ', '');
          RequestReceiptHttpService.requestReceipt = data;
        } else {
          RequestReceiptHttpService.requestReceipt = null;
        }
        this.newRequestIncoming.next();
      });
  }

  disconnectSocket() {
    if (this.unsubscribeRequestReceipt) {
      this.unsubscribeRequestReceipt();
    }
    if (this.requestReceiptChannelName) {
      this.socketIoService.leave(this.requestReceiptChannelName);
    }
    this.unsubscribeRequestReceipt = null;
    this.requestReceiptChannelName = null;
  }

}
